import React, { memo } from 'react';
import { MechanicalContractor } from './types';

interface MechanicalContractorSubOfficesProps {
  contractor: MechanicalContractor;
}

const MechanicalContractorSubOffices = memo(({
  contractor
}: MechanicalContractorSubOfficesProps) => {
  const subOffices = contractor.address?.filter(addr => addr.addressType === 'sub-office') || [];

  return (
    <div className="space-y-6">
      <div>
        <dt className="text-sm font-medium text-gray-900 mb-2">Sub Offices</dt>
        <dd className="text-sm text-gray-700">
          {subOffices.length === 0 ? (
            <span className="italic">No sub offices</span>
          ) : (
            <div className="space-y-2">
              {subOffices.map((office, index) => (
                <div key={index} className="text-md">
                  {[office.address, office.city, office.province?.name].filter(Boolean).join(', ')}
                  {office.postalCode && ` ${office.postalCode}`}
                </div>
              ))}
            </div>
          )}
        </dd>
      </div>
    </div>
  );
});

MechanicalContractorSubOffices.displayName = 'MechanicalContractorSubOffices';

export default MechanicalContractorSubOffices;